<template>
    <v-card class="wrapper" ref="mainContainer" :loading="projectSupplierStatsLoading" color="#313131">

        <v-card-text>

            <div class="align-self-center title grey--text text--lighten-2 d-flex ml-3">

                <div class="align-self-center">{{ project.name }}</div>

                <v-chip label small class="align-self-center grey--text text--lighten-1 ml-2 mr-2">
                    {{ project.id }}
                </v-chip>

                <v-btn icon @click="reloadClicked">
                    <v-icon>mdi-reload</v-icon>
                </v-btn>
            </div>

            <div class="d-flex flex-wrap ml-3 mr-3 mt-4">

                <title-card background-color="grey darken-2"
                            class="chartContainer mr-2"
                            side-icon="mdi-network-outline"
                            :loading="projectSupplierStatsLoading"
                            :title="supplier.name"
                            v-for="supplier in suppliers"
                            :no-padding="true"
                            :key="supplier.name">

                    <template slot="buttons">

                        <v-tooltip color="primary" max-width="400" top>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" @click="downloadClicked(supplier.id)" text small
                                       v-if="hasPermission('update projects')">
                                    <v-icon left>mdi-download</v-icon>
                                    Export
                                </v-btn>
                            </template>
                            Export a list of participants and their statuses
                        </v-tooltip>
                    </template>

                    <supplier-chart
                        :name="supplier.name"
                        :data="supplier.data"
                    ></supplier-chart>

                    <v-tooltip color="primary" max-width="400" top>
                        <template v-slot:activator="{ on }">

                            <v-progress-linear v-on="on" height="25"
                                               :value="supplier.max_completes_percent"
                                               :color="progressColor(supplier)">

                                <template v-slot:default="{ value }">
                                    <strong>
                                        {{ supplier.max_completes_percent }}%
                                    </strong>
                                </template>

                            </v-progress-linear>
                        </template>
                        Supplier completes {{ supplier.completed_count }} / {{ supplier.max_completes }} or
                        {{ supplier.max_completes_percent }}%
                    </v-tooltip>

                </title-card>

            </div>

        </v-card-text>

    </v-card>
</template>

<script>

import Json from 'vue-json-pretty';
import {mapState, mapActions} from 'vuex';
import SupplierChart from "./SupplierChart";
import MaterialHeader from "../../../../components/UI/MaterialHeader";
import TitleCard from "../../../../components/UI/TitleCard";

const vuexModule = 'ProjectManager';
const reportNames = ['completed', 'profile', 'quota', 'duplicate', 'quality', 'error', 'security']

export default {

    components: {
        TitleCard,
        MaterialHeader,
        SupplierChart,
        Json
    },

    props: {
        project: {
            required: true,
            type: Object,
        }
    },

    computed: {
        ...mapState(vuexModule, [
            'projectSupplierStats',
            'projectSupplierStatsLoading'
        ]),
    },

    data() {
        return {
            height: null,
            suppliers: []
        }
    },

    methods: {
        ...mapActions(vuexModule, [
            'getProjectSupplierStats',
            'getProjectSupplierDownload'
        ]),

        reloadClicked() {
            this.loadSupplierStats(true);
        },

        progressColor(supplier) {
            if (supplier.max_completes_percent > 95) return 'red darken-4';
            if (supplier.max_completes_percent > 85) return 'amber darken-4';
            if (supplier.max_completes_percent > 75) return 'yellow darken-3';
            return 'green darken-2';
        },

        loadSupplierStats(force = false) {
            this.getProjectSupplierStats(this.project.id)
                .then(response => {

                    this.createSuppliersData(response.data.supplier_totals);

                    if (force) {
                        Bus.$emit('flash-message', {type: 'info', message: 'Supplier statistics reloaded!'})
                    }
                })
                .catch(error => {

                    console.log(error);

                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'OOPS! Suppliers statistics failed to load.'
                    })
                })
        },

        createSuppliersData(totals) {

            this.suppliers = [];

            totals.forEach(supplier => {

                let items = [];

                reportNames.forEach(name => {

                    const field = name + "_count";

                    if (supplier[field] > 0) {

                        items.push({
                            name: this.ucFirst(name),
                            value: supplier[field]
                        });
                    }
                });

                this.suppliers.push({
                    id: supplier.id,
                    name: supplier.name,
                    max_completes: supplier.max_completes,
                    max_completes_percent: supplier.max_completes_percent,
                    completed_count: supplier.completed_count,
                    data: items
                });
            })
        },

        downloadClicked(supplierId) {

            this.getProjectSupplierDownload({
                projectId: this.project.id,
                supplierId: supplierId,
            })
                .then(response => {
                    Bus.$emit('flash-message', {
                        type: 'info',
                        message: 'The participant report is now generating and will be placed in the Downloads!'
                    })
                })
                .catch(error => {
                    console.log(error);
                    Bus.$emit('flash-message', {type: 'error', message: 'OOPS! Supplier download failed to start.'})
                });
        }
    },

    mounted() {
        this.loadSupplierStats();
    }
}
</script>

<style scoped>

.chartContainer {
    height: 350px;
    width: 500px;
}

.wrapper {
    /* vuetify sets the v-tabs__container height to 48px */
    height: calc(100vh - 48px);
}
</style>